/**
 * Swatch images for V&B pad flow — matches legacy /gallery/pads/vorst/ paths.
 * Slugs are keyed by normalized option description (aligned with ViCore.Seeder / old site).
 */

const GUMLET_BASE = 'https://vinc.gumlet.io/gallery/pads/vorst'

function normalize(desc: string | null | undefined): string {
  return (desc ?? '').trim().toLowerCase()
}

/** Pad base options (leather / vegan) — image under bases/{slug}.jpg */
const BASE_DESC_TO_SLUG: Record<string, string> = {
  'black leather': 'black',
  'black vegan leather': 'black',
  'brown leather': 'brown',
  'brown vegan leather': 'brown',
  'white leather': 'white',
  'white vegan leather': 'white',
}

/** Insert color options — image under vorst/{slug}.jpg */
const INSERT_DESC_TO_SLUG: Record<string, string> = {
  green: 'erdnasegreen',
  red: 'red',
  black: 'black',
  burgundy: 'burgundy',
  'light pink': 'light-pink',
  'deep blue': 'deep-blue',
  'light blue': 'light-blue',
  yellow: 'yellow',
  grey: 'grey',
  orange: 'orange',
}

export function vorstBaseSwatchUrl(description: string | null | undefined): string | null {
  const slug = BASE_DESC_TO_SLUG[normalize(description)]
  if (!slug) return null
  return `${GUMLET_BASE}/bases/${slug}.jpg?w=280&dpr=2`
}

export function vorstInsertSwatchUrl(description: string | null | undefined): string | null {
  const slug = INSERT_DESC_TO_SLUG[normalize(description)]
  if (!slug) return null
  return `${GUMLET_BASE}/${slug}.jpg?w=280&dpr=2`
}
